export enum MessageType {
  Message, Image, Radio, Checkbox, Contact, Text, Textarea
}
